import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { QRCodeModule } from "angularx-qrcode";
import { NbButtonModule, NbIconModule } from "@nebular/theme";
import { NbEvaIconsModule } from "@nebular/eva-icons";
import { TyaQrcodeComponent } from "./tya-qrcode.component";
import { NgxQrcodeStylingModule } from "ngx-qrcode-styling";

@NgModule({
  declarations: [TyaQrcodeComponent],
  imports: [
    FormsModule,
    CommonModule,
    QRCodeModule,
    NbButtonModule,
    NbEvaIconsModule,
    NbIconModule,
    NgxQrcodeStylingModule,
  ],
  exports: [TyaQrcodeComponent],
})
export class TyaQrcodeModule {}
